/** Bump when Subscription Terms / consent copy changes (Stripe metadata + DB). */
export const DIGITAL_CONTENT_CONSENT_VERSION = '2026-03'

export const SUBSCRIPTION_TERMS_PATH = '/subscription-terms'
export const FAIR_USE_POLICY_PATH = '/fair-use'
export const PRIVACY_POLICY_PATH = '/privacy-policy'

export const LEGAL_CONTACT_EMAIL = 'support@rondanini.com'
